




























import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
const getInitialState = initialCourse => ({
  title: initialCourse.settings?.seo?.title || '',
  metaDescription: initialCourse.settings?.seo?.metaDescription || '',
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  methods: {
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
  },
  watch: {
    ...['title', 'metaDescription'].reduce((acc, name) => {
      acc[name] = function (current, prev) {
        if (prev !== current) {
          this.onChange({
            name,
            data: current,
            path: ['settings', 'seo', name],
            hasDiff: getInitialState(this.initialCourse)[name] !== current,
          });
        }
      };
      return acc;
    }, {}),
  },
};
